import React, { Component } from "react";
import Select from "react-select";
import { Field, reduxForm } from 'redux-form'

import { connect } from 'react-redux';
import { InputField } from '../../inputField';

import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { StartOfThisMonthDatePicker, DatePicker } from '../../datePicker';
import { Selection, DisabledSelection, SelectionWithProps } from '../../selection';

const changeDeliveryTime = (data, success, sales_order_id) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/sales_order/${sales_order_id}/dispatch_date`,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      success();
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}

const fetchDeliveryTime = (cb) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/mobile/delivery_time`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      cb(res.data)
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}

const fetchDeliveryTimeNext = (cb) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/mobile/delivery_time_next`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  })
    .then(res => {
      cb(res.data);
    }, err => {
      console.log(err);
      // alert(err.statusText);
    })
}


const modalStyle = {
  width: '300px',
  height: '220px',
  marginLeft: '-5%',
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class form extends Component {
  state = {
    DispatchDateOptions: [],
  }
  componentDidMount() {
    fetchDeliveryTime((date1) => {
      fetchDeliveryTimeNext((date2) => {
        const DispatchDateOptions = [...date1, ...date2].map(d => ({
          label: d.name,
          value: d.value,
        }));
        this.setState({
          DispatchDateOptions,
        });
      })
    })
    ;
  }

  handleFormSubmit = formProps => {
    if (!formProps.DispatchDate) return;
    const success = () => {
      this.props.onSuccess();
    }
    changeDeliveryTime({
      DispatchDate: formProps.DispatchDate.value,
    }, success, this.props.selectedRows[0].SalesOrder_id)
  }

  render() {
    const {
      handleSubmit
    } = this.props;
    return (
      <form style={{ width: '100%', padding: '10px' }}>
        <div className="form-group" style={{ marginTop: '10px' }}>
          <div className="col-xs-12">
            <Field name="DispatchDate" component={Selection} options={this.state.DispatchDateOptions} />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '100%', marginTop: '70px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={this.props.setModalVisibility}
          >
            <Translate value="cancel" />
          </Button>
          <span style={{ width: '50px' }} />
          <Button
            bsStyle="success"
            className="print-btn"
            type="button"
            onClick={handleSubmit(this.handleFormSubmit)}
          >
            <Translate value="confirm" />
          </Button>
        </div>
      </form>
    )
  }
}

const DeliveryTimeChangeForm = reduxForm({
  // a unique name for the form
  form: 'DeliveryTimeChangeForm',
  enableReinitialize: true,
})(form);


const DeliveryTimeChange = ({ setModalVisibility, isVisible, estDeliveryEditingSOID, selectedRows, onSuccess }) => (
  <SkyLightStateless
    title={'Delivery Time'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <DeliveryTimeChangeForm setModalVisibility={setModalVisibility} estDeliveryEditingSOID={estDeliveryEditingSOID} selectedRows={selectedRows} onSuccess={onSuccess}/>
  </SkyLightStateless>
)

DeliveryTimeChange.propTypes = propTypes;
DeliveryTimeChange.defaultProps = defaultProps;

export default DeliveryTimeChange;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/DeliveryTimeChange.jsx